module.exports = __webpack_public_path__ + "img/icb-leo-novice-m@2x.56808826.png";